import { tourStep } from './tourRegistry';

export const bandaContactosSteps = [
  tourStep(
    'contactos-header',
    'Agenda',
    'Refuerzos, proveedores y entidades con las que trabajáis, aparte de la plantilla de Mis músicos.',
  ),
  tourStep(
    'contactos-categoria',
    'Categorías',
    'Las pestañas fijas cubren lo habitual. Desde aquí creas una categoría propia si os hace falta otra.',
  ),
  tourStep(
    'contactos-pestanas',
    'Pestañas',
    'Cada pestaña es una lista distinta. Cambia de una a otra para no mezclar refuerzos con proveedores.',
  ),
  tourStep(
    'contactos-anadir',
    'Añadir contacto',
    'Nombre, teléfono y, si es un refuerzo, el instrumento. Luego puedes escribirle por WhatsApp desde la ficha.',
    'left',
  ),
];
